import { APIcallerv2 } from './APIcaller';

export const getSalesByStoreId = (storeId, startDate, endDate) =>
  APIcallerv2.apiGet(`/sales/stores/${storeId}`, { startDate, endDate });

export default {
  getSalesByStoreId,
};
